import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { ALL_BIDS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAllBidsSocket'
import { allBidsQueryKey } from '@autobid/ui/composables/car/useAllBids'
import { useQueryClient } from '@tanstack/vue-query'

export function useAllBidsItemPublish() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const itemPublish = () => {
    startListen({
      eventName: 'premium.ITEM_PUBLISH',
      callbackName: ALL_BIDS_SOCKET_CALLBACK,
      callback: (event) => {
        const queryKey = allBidsQueryKey.byCarId(event.context.itemId)
        queryClient.invalidateQueries(queryKey)
      },
    })
  }

  return { itemPublish }
}
